export const getValue = (d, key) => {
  return d.responses[key] + d.overCounts["maxIntegerSize"] * d.overCounts[key];
}

export const getTotal = (values) => {
  let t = 0;
  Object.keys(values).map((k, i) => {
    t += values[k];
  });
  return t;
}

export const bTh = (b, unit = "GiB") => {
  let kb = unit === "GiB" ? 1024 : 1000;

  if (!b && b !== 0) {
    return "-";
  }

  if (typeof b !== 'number') {
    return b;
  }

  if (b < kb) {
    return b + ' B';
  }

  if (b < (kb * kb)) {
    return (b / kb).toFixed(2) + (unit === "GiB" ? ' KiB' : ' KB');
  }

  if (b < (kb * kb * kb)) {
    return (b / (kb * kb)).toFixed(2) + (unit === "GiB" ? ' MiB' : ' MB');
  }

  if (b < (kb * kb * kb * kb)) {
    return (b / (kb * kb * kb)).toFixed(2) + (unit === "GiB" ? ' GiB' : ' GB');
  }

  return (b / (kb * kb * kb * kb)).toFixed(2) + (unit === "GiB" ? ' TiB' : ' TB');
}

export const mTh = (msec) => {
  var ms = 1000, m = 60, h = m * m, d = h * 24, s = '';

  if (!msec && msec !== 0) {
    return "-";
  }

  if (msec < ms) {
    return msec + 'ms';
  }

  if (msec < (ms * m)) {
    return Math.floor(msec / ms) + '.' + Math.floor((msec % ms) / 10) + 's';
  }

  var days = Math.floor(msec / (d * ms));
  if (days) {
    s += days + "d ";
  }

  var hours = Math.floor((msec % (d * ms)) / (h * ms));
  if (days || hours) {
    s += hours + "h ";
  }

  var minutes = Math.floor(((msec % (d * ms)) % (h * ms)) / (m * ms));
  if (days || hours || minutes) {
    s += minutes + "m ";
  }

  var seconds = Math.floor((((msec % (d * ms)) % (h * ms)) % (m * ms)) / ms);

  return s + seconds + "s";
}

export const sTh = (b,d) => {
  var s;
  if (!b && !d) {
    s = "up";
  } else if (d) {
    s = "down";
  } else {
    s = "backup";
  }
  return s;
}